"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchField = void 0;
var _react = _interopRequireWildcard(require("react"));
var _device = require("b2b-components/utils/device");
var _SearchField = require("./SearchField");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var SearchFieldContainer = function SearchFieldContainer(_ref) {
  var onSubmit = _ref.onSubmit,
    onInputChange = _ref.onInputChange,
    onClearButtonClick = _ref.onClearButtonClick,
    onInputKeyDown = _ref.onInputKeyDown,
    onScanCodeButtonClick = _ref.onScanCodeButtonClick,
    value = _ref.value,
    isLoading = _ref.isLoading,
    placeholder = _ref.placeholder,
    deviceType = _ref.deviceType,
    dataAttributes = _ref.dataAttributes,
    className = _ref.className;
  var hasScanCodeButton = !!onScanCodeButtonClick && !(value.length > 0) && (0, _device.isMobile)(deviceType);
  var inputRef = (0, _react.useRef)(null);
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    onSubmit();
  };
  var handleClick = function handleClick(e) {
    e.stopPropagation();
  };
  var handleScanCodeButtonClick = function handleScanCodeButtonClick(e) {
    e.stopPropagation();
    onScanCodeButtonClick === null || onScanCodeButtonClick === void 0 ? void 0 : onScanCodeButtonClick();
  };
  var handleClearButtonClick = function handleClearButtonClick(e) {
    var _inputRef$current, _inputRef$current$foc;
    e.stopPropagation();
    onClearButtonClick();
    inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : (_inputRef$current$foc = _inputRef$current.focus) === null || _inputRef$current$foc === void 0 ? void 0 : _inputRef$current$foc.call(_inputRef$current);
  };
  var handleInputKeyDown = function handleInputKeyDown(e) {
    onInputKeyDown === null || onInputKeyDown === void 0 ? void 0 : onInputKeyDown(e);
  };
  return /*#__PURE__*/_react["default"].createElement(_SearchField.SearchField, {
    onClick: handleClick,
    onSubmit: handleSubmit,
    onInputChange: onInputChange,
    onInputKeyDown: handleInputKeyDown,
    onClearButtonClick: handleClearButtonClick,
    onScanCodeButtonClick: handleScanCodeButtonClick,
    hasScanCodeButton: hasScanCodeButton,
    value: value,
    isLoading: isLoading,
    placeholder: placeholder,
    deviceType: deviceType,
    inputRef: inputRef,
    dataAttributes: dataAttributes,
    className: className
  });
};
exports.SearchField = SearchFieldContainer;